import axios from 'axios'

export default {
    async getNowShowing() {
        try
        {            
            const response = await axios.get(`PublicNotification/now-showing`)              
            return response
        }
        catch (error)
        {
            console.log('PublicNotification api getNowShowing error')
            throw error
        }
    },
}